import React, { useEffect, useState } from 'react';
import PlayerPicker from '../../players/PlayerPicker';
import * as playersApi from '../../../api/players';

/**
 * Optional wizard step: pick people to invite as soon as the thing exists.
 *
 * Seeded from your play history rather than a roster, because at this point
 * there is no roster - the game or league does not exist yet. Nobody is
 * pre-selected here, unlike the pickers that open on an existing group: a brand
 * new game is not obviously "the same crowd again", and silently ticking your
 * whole address book on a screen you might skip past is not a good default.
 */
function InviteStep({ selectedIds, onToggle }) {
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let live = true;
    playersApi.getPlayedWith()
      .then((list) => {
        if (live) setPlayers(list || []);
      })
      .catch(() => {
        if (live) setPlayers([]);
      })
      .finally(() => {
        if (live) setLoading(false);
      });
    return () => {
      live = false;
    };
  }, []);

  return (
    <div className="form-group">
      <label>Invite people (optional)</label>
      {loading ? (
        <p className="helper-text">Finding people you play with...</p>
      ) : (
        <PlayerPicker
          players={players}
          selectedIds={selectedIds}
          onToggle={onToggle}
          emptyHint="Once you've played some games, the people you play with most show up here."
        />
      )}
      <p className="helper-text">
        They each get an invitation to accept or decline. You'll get a code to
        share as well, so you can skip this and invite people later.
      </p>
    </div>
  );
}

export default InviteStep;
